import React from "react";
import { WidgetDetails, Title, BlogImg } from "../../assets/styled/BlogStyle";

const Blog_3 = () => {
  return (
    <>
      <BlogImg src="https://www.raktherm.com/images/blog3.jpeg" alt="blog-1" />
      <Title style={{ marginBottom: "0px" }}>
        Innovator of UV Fittings System
      </Title>
      <Title>Anti-UV Piping Systems for Areas With Heavy Sun Exposure</Title>
      <WidgetDetails>
        Anti-UV piping systems are better than regular ones in situations
        exposed to sunlight. That's because ultraviolet (UV) rays from the sun
        can cause damage to many types of plastics, including those used in
        pipes.
      </WidgetDetails>

      <WidgetDetails>
        RAKtherm anti-UV systems are integrated with unique black anti-UV
        technology for higher resistance against UV rays intended for outdoor
        applications under direct sunlight. It is the safest and longest-lasting
        piping solution for outdoor installation.
      </WidgetDetails>

      <WidgetDetails>
        The creation of RAKtherm anti-UV fittings provides a complete lineup of
        piping solutions for outdoor installations. Here are some reasons why
        you should choose these for your next project:
      </WidgetDetails>

      <Title>Increased lifespan</Title>
      <WidgetDetails>
        Exposure to UV rays can cause plastic pipes to become brittle and crack
        over time, reducing lifespan. Anti-UV piping systems are designed to
        resist the effects of UV radiation, which can extend their lifespan.
      </WidgetDetails>

      <Title>Lower maintenance costs</Title>
      <WidgetDetails>
        Pipes that become brittle and crack due to UV exposure may need to be
        replaced, which can be costly. By using anti-UV piping systems, you can
        avoid the need for frequent replacements and reduce maintenance costs.
      </WidgetDetails>

      <Title>Higher safety</Title>
      <WidgetDetails>
        UV rays can also affect the safety of pipes used in specific
        applications, such as water distribution systems. When UV radiation
        breaks down the plastic, it can release harmful chemicals into the water
        supply. Anti-UV piping systems are designed to minimize this risk and
        ensure the water supply remains safe.
      </WidgetDetails>

      <Title>Improved performance</Title>
      <WidgetDetails>
        Pipes exposed to UV radiation can also experience a performance loss
        over time. Anti-UV piping systems can maintain their structural
        integrity and performance, even when exposed to sunlight.
      </WidgetDetails>
      <WidgetDetails>
        We are one of the first manufacturers of anti-UV fittings registered in
        SKZ, affirming our adherence to the highest quality standard. Interested
        in rolling out anti-UV piping systems for your next project? Discuss
        your requirements with one of our customer success representatives here.
      </WidgetDetails>
    </>
  );
};

export default Blog_3;
